import { Base } from "../../framework/base";
import { EditItem, IEditItem } from "../common/editItem";
import { EventUserState } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IRecordEditItemUserFamiliarization extends IEditItem {
    familiarizationId: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    trainer: string;
    comment: string;
    activeState: number;
    modifyUser: IModifyUser;
    handlers: IModifyUser[];

    getUserState(userCode: string): EventUserState;
}

export class RecordEditItemUserFamiliarization extends EditItem implements IRecordEditItemUserFamiliarization {
    familiarizationId: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    trainer: string;
    comment: string;
    activeState: number;
    modifyUser: ModifyUser;
    handlers: ModifyUser[];

    constructor();
    constructor(obj: IRecordEditItemUserFamiliarization);
    constructor(obj?: any) {
        super(obj);
        this.familiarizationId = obj && obj.familiarizationId || "";
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.trainer = obj && obj.trainer || "";
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
        this.modifyUser = new ModifyUser(obj?.modifyUser);
        this.handlers = Base.getTypedArray(obj?.handlers, ModifyUser);
    }

    getUserState(userCode: string): EventUserState {
        const user = this.handlers.find(i => i.code === userCode);
        if (!user) return EventUserState.NotHandler;
        return user.date > 0 ? EventUserState.Approved : EventUserState.NotApproved;
    }
}

export type TRecordEditItemFamiliarizationSaveHandler = {
    userCode: string;
    approved: boolean;
}

export class RecordEditItemUserFamiliarizationSave extends EditItem {
    familiarizationId: string;
    startDate: number;
    endDate: number;
    validityEndDate: number;
    trainer: string;
    comment: string;
    activeState: number;
    handlers: TRecordEditItemFamiliarizationSaveHandler[];

    constructor();
    constructor(obj: IRecordEditItemUserFamiliarization);
    constructor(obj?: any) {
        super(obj);
        this.familiarizationId = obj && obj.familiarizationId || "";
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj && obj.endDate || null;
        this.validityEndDate = obj && obj.validityEndDate || null;
        this.trainer = obj && obj.trainer || "";
        this.comment = obj && obj.comment || "";
        this.activeState = obj && obj.activeState || 0;
        this.handlers = [];
    }
}